import edit from './edit';
import softDelete from './delete';

export default {
  edit,
  softDelete
}